/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleCircleIcon20Light = forwardRef('MoneyCurrencyRubleCircleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 11h2a3 3 0 1 0 0-6H8.955A.955.955 0 0 0 8 5.955V10H7a.5.5 0 0 0 0 1h1v1H7a.5.5 0 0 0 0 1h1v1.5a.5.5 0 0 0 1 0V13h3a.5.5 0 0 0 0-1H9v-1Zm0-5v4h2a2 2 0 1 0 0-4H9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z" })));
});
